/**
 * 统一社会信用代码：长度与常用字符校验（GB 32100-2015 为 18 位）
 */

const USCC_LENGTH = 18
const USCC_PATTERN = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/i

/** 去空白、全角转半角、转大写，避免计数 18/18 但 trim 后不足 18 位 */
export function normalizeUnifiedSocialCreditCode(raw: unknown): string {
  return String(raw ?? '')
    .replace(/[\s\u00a0\u3000]+/g, '')
    .replace(/[\uFF10-\uFF19]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xff10 + 0x30))
    .replace(/[\uFF21-\uFF3A]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xff21 + 0x41))
    .replace(/[\uFF41-\uFF5A]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xff41 + 0x41))
    .toUpperCase()
}

/** 是否为合法的 18 位统一社会信用代码（长度 + 字符集；不含校验位强校验） */
export function isValidUnifiedSocialCreditCodeLength(raw: string): boolean {
  return normalizeUnifiedSocialCreditCode(raw).length === USCC_LENGTH
}

/** 长度与字符格式均符合时返回 true（规范化后非空才校验） */
export function isValidUnifiedSocialCreditCode(raw: string): boolean {
  const code = normalizeUnifiedSocialCreditCode(raw)
  if (!code) return false
  return code.length === USCC_LENGTH && USCC_PATTERN.test(code)
}

export const UNIFIED_SOCIAL_CREDIT_CODE_LENGTH = USCC_LENGTH
